import React, { Component } from 'react';
import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app
import { TreeWrapper } from './styles';
import { AP_TAXONOMY_TREE_DATA_PARAMS } from 'TaxonomyMapperPreview/Container';
import { fetchWheelChartData } from 'utils/apiRequests';
import { taxonomyMapperDataConverter } from 'utils/taxonomyMapperDataConverter';
import { TAXONOMY_TREE_DATA_PARAMS } from 'TaxonomyMapper/TaxonomyMapperContainer';
const GET_TREE_PARAMS = type => {
	switch (type) {
		case 2:
			return AP_TAXONOMY_TREE_DATA_PARAMS;
		case 3:
			return TAXONOMY_TREE_DATA_PARAMS;
		default:
			break;
	}
};
export default class NewSortableTree extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currentSelected: [...(props.sidebarConfig.flatData || [])],
			selectedNodes: [...(props.sidebarConfig.flatData || [])],
			expandedNodes: [],
			treeData: [],
			flatData: [],
		};
	}
	componentDidMount() {
		this.fetchTreeData();
	}
	handleNodeToggle = ({ node }) => {
		let expandedNodes = this.state.expandedNodes.slice();

		const expanded = expandedNodes.some(
			expandedNode => expandedNode === node.id
		);
		if (!expanded) {
			expandedNodes.push(node.id);
		} else {
			expandedNodes = expandedNodes.filter(
				expandedNode => expandedNode !== node.id
			);
		}

		this.setState({ expandedNodes });
	};

	handleNodeSelect = ({ event, node, selected }) => {
		let currentSelected = this.state.currentSelected.slice();
		let selectedNodes = this.state.selectedNodes.slice();
		if (currentSelected.findIndex(obj => obj.id === node.id) === -1) {
			if (selected) {
				const { flatData } = this.state;

				let selectedNodeId = node.id;
				const nodeIds = [];
				const selectedNodeIds = selectedNodeId
					.substring(1, selectedNodeId.length - 1)
					.split('/');
				let currentPath = '';
				selectedNodeIds.forEach(string => {
					currentPath += (currentPath ? '/' : '') + string;
					nodeIds.push(currentPath);
				});

				for (let i = 0; i < nodeIds.length; i++) {
					selectedNodes.push(
						flatData.find(
							obj => obj.id === '/' + nodeIds[i] + '/' && obj.depth === i + 1
						)
					);
				}
				this.props.setData(selectedNodes);
				this.setState({ selectedNodes });
			} else if (selectedNodes.findIndex(obj => obj.id !== node.id) !== -1) {
				selectedNodes = selectedNodes.filter(
					selectedNode => selectedNode.id !== node.id
				);
				this.props.setData(selectedNodes);
				this.setState({ selectedNodes });
			}
		}
	};
	async fetchTreeData() {
		const { taxonomyType } = this.props;
		const apiRequestParams = { ...GET_TREE_PARAMS(taxonomyType) };
		if ('gbp') {
			apiRequestParams.currency = 'gbp';
			apiRequestParams.currencyType = 'fixed';
		}

		const data = await fetchWheelChartData(apiRequestParams);
		this.setState({
			flatData: data.data.map(data => ({
				...data,
				title: data.label,
				originalId: data.id,
			})),
		});
		let treeData = taxonomyMapperDataConverter.convert(data.data, true);
		const topLevelItem = {
			title: 'Category Tree',
			id: 'AlixPartners taxonomy',
			originalId: 'AlixPartners taxonomy',
			level: -1,
			expanded: true,
			children: [...treeData],
			value: treeData.reduce((acc, item) => acc + item.value, 0),
		};

		treeData = [topLevelItem];
		this.setState({ treeData });

		return treeData;
	}
	render() {
		const { selectedNodes, expandedNodes } = this.state;

		return (
			<TreeWrapper>
				<SortableTree
					treeData={this.state.treeData}
					onChange={treeData => {
						this.setState({ treeData });
					}}
					canDrag={false}
					onVisibilityToggle={this.handleNodeToggle}
					isNodeExpanded={({ node }) => expandedNodes.includes(node.id)}
					generateNodeProps={({ node }) => ({
						style: {
							background: selectedNodes.some(
								selectedNode => selectedNode.id === node.id
							)
								? 'lightgreen'
								: 'white',
						},
						onClick: event => {
							if (
								event.target.className !== 'rst__expandButton' &&
								event.target.className !== 'rst__collapseButton'
							) {
								this.handleNodeSelect({
									event,
									node,
									selected: !selectedNodes.some(
										selectedNode => selectedNode.id === node.id
									),
								});
							}
						},
					})}
				/>
			</TreeWrapper>
		);
	}
}
